var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "14px",
    viewBox: "0 0 22 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1415.000000, -731.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content-options",
    transform: "translate(653.000000, 665.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(65.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(490.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-animate",
    transform: "translate(207.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99855029,13.9289036 C2.60696294,13.4430503 4.89386309e-13,10.5259695 4.89386309e-13,7 C4.89386309e-13,3.47403046 2.60696294,0.556949738 5.99855029,0.0710963786 C3.6081443,1.45454028 2,4.03946903 2,7 C2,9.96053097 3.6081443,12.5454597 5.99855029,13.9289036 Z",
    id: "Combined-Shape",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99855029,13.9289036 C6.60696294,13.4430503 4,10.5259695 4,7 C4,3.47403046 6.60696294,0.556949738 9.99855029,0.0710963786 C7.6081443,1.45454028 6,4.03946903 6,7 C6,9.96053097 7.6081443,12.5454597 9.99855029,13.9289036 Z",
    id: "Combined-Shape",
    opacity: 0.600000024
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15,
    cy: 7,
    r: 7
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnimate);
export default __webpack_public_path__ + "static/media/icon-animate.258c7366daa30ecdfb4bb8adbcaa1938.svg";
export { ForwardRef as ReactComponent };